export const NO_ITEM_WITH_THAT_ID = 'No item with that ID';
export const ITEM_IS_NOT_AVAILABLE_FOR_PURCHASE = 'This item is not available for purchase anymore';
export const NOT_ENOUGH_BALANCE = 'Amount withdrawn must be less than or equal than the balance of the Vault';
